import React from "react";
import Box from "@mui/material/Box";
import { isErrorMessage } from "@sscs/types";
import { getClassName } from "@sscs/utils";
import { LoadingDots } from "../../index";
import styles from "./queryResult.module.scss";
const parseErrorMessage = (error) => {
    if (isErrorMessage(error))
        return error.data.error;
    else
        return "Unknown error";
};
/**
 * Wraps components that fetch from the server and renders indicators or data by status.
 * @param status From RTK Query's `useQuery` return via the `getStatus` util
 * @param disableFetching Suppress the fetching overlay
 * @param errorTitle Overrides the default error heading for a domain-specific failure
 * @param errorMessage Overrides the parsed error body for a domain-specific failure
 */
const QueryResult = ({ status, disableFetching = false, fetchingClassName, errorTitle, errorMessage, children, }) => {
    if (status.status === "ERROR")
        return (React.createElement(Box, { sx: {
                // eslint-disable-next-line id-length
                m: 2,
            } },
            React.createElement("h2", { className: styles["error-title"] }, errorTitle !== null && errorTitle !== void 0 ? errorTitle : "Could not fetch data."),
            React.createElement("p", null, errorMessage !== null && errorMessage !== void 0 ? errorMessage : (status.error ? parseErrorMessage(status.error) : "Unknown error"))));
    if (status.status === "LOADING")
        return React.createElement(LoadingDots, null);
    const isFetching = status.status === "FETCHING" && !disableFetching;
    return (React.createElement("div", { "data-query-result": "true", "data-testid": isFetching ? "fetching" : undefined, className: getClassName(styles["fetching-wrapper"], {
            [fetchingClassName !== null && fetchingClassName !== void 0 ? fetchingClassName : styles.fetching]: isFetching,
        }) }, children));
};
export default QueryResult;
//# sourceMappingURL=QueryResult.js.map